import {FC} from "react";
import {useTranslation} from "react-i18next";
import {UserClimbingEvent} from "../../../models/UserClimbingEvent";
import {ClimbingEvent} from "../../../models/ClimbingEvent";
import {FormControl, InputLabel, MenuItem, Select} from "@mui/material";


type Props = {
  userClimbingEvent: UserClimbingEvent,
  handleBestRouteChange: (routeId: number) => void,
  climbingEvent : ClimbingEvent
}

export const PickBestRoute: FC<Props> = ({userClimbingEvent,handleBestRouteChange,climbingEvent}) => {
  const {t} = useTranslation();

  return (

      <FormControl fullWidth>
        <InputLabel sx={{fontWeight:600}} id="pick-best-route-label">{t('event.bestRoute')}</InputLabel>
        <Select
        value={userClimbingEvent.bestRouteId}
        variant="standard"
        labelId="pick-best-route-label"
        onChange={(e) => handleBestRouteChange(e.target.value as number)}
        >
        {climbingEvent.routes.map(route => <MenuItem value={route.id}>{route.id}</MenuItem>)}
     </Select>
      </FormControl>
     )
}